export default {
  getEvents: (state) => state.events,
  programUIState: (state) => state.programUIState
}